import { DateRange } from './date';

export class Vouchers {
  id: number;
  appCode: number;
  groupName: string;
  description: string;
  scrollType: string;
}

export class VouchersSearch {
  createdDate: DateRange = DateRange.empty();
  id = '';
  appCode = '';
  name = '';
  title = '';
  description = '';
  termsAndCondition = '';
  type = '';
  merchantId = '';
  merchantPrefunded = '';
  costPerVoucher = '';
  value = '';
  validity = '';
  quantity = '';
  allowedQty = '';
  miniumActivePoints = '';
  startDate = '';
  endDate = '';
  locationId = '';
  isAvailable = '';
  purchaseType: any;
}

export class VoucherIssuance {
  createdDate: DateRange = DateRange.empty();
  voucherName = '';
  appCode = '';
  code = '';
  status = '';
  name = '';
  title = '';
  description = '';
  termsAndCondition = '';
  type = '';
  merchantId = '';
  merchantPrefunded = '';
  issuedAgentId = '';
  purchaseType = '';
  costPerVoucher = '';
  value = '';
  validity = '';
  quantity = '';
  allowedQty = '';
  miniumActivePoints = '';
  startDate = '';
  endDate = '';
  agentName = '';
  merchant = '';
  location = '';
}
